import React, { ReactElement } from 'react';

import { formatDate } from '../../../../../utils/date.util';

import { SearchResult } from '../../../../../types/entity.types';

import TextHighlighter from '../../../../common/highlighter/TextHighlighter';

import './tribe-search-result.scss';

type Props = {
  searchValue: string;
  result: SearchResult;
  onLoadPostWithHierarchy: (value: string) => void;
};

const TribeSearchResult = ({ searchValue, result, onLoadPostWithHierarchy }: Props): ReactElement => (
  <div className="tribe-search-result" onClick={(): void => onLoadPostWithHierarchy(result.externalReference)}>
    <div className="tribe-search-result__header">
      <p className="tribe-search-result__type">{result.postType}</p>
      <p>&nbsp;-&nbsp;</p>
      <p className="tribe-search-result__name">{result.member}</p>
    </div>
    <p className="tribe-search-result__date">{formatDate(result.dateTime)}</p>
    <p className="tribe-search-result__content">
      <TextHighlighter source={result.text} target={searchValue} />
    </p>
  </div>
);

export default TribeSearchResult;
